import axios from 'axios';
import config from '../config';
import { CreateDeviceForm } from '../interfaces';

export const createOnboardDevice = (device: CreateDeviceForm) => {
    return axios.post(`${config.API_URL}/onboard-devices`, device).then((response: any) => {
        return response.data.message;
    });
};
